import { A } from '@ember/array';
import Transform from '@ember-data/serializer/transform';

import type NativeArray from '@ember/array/-private/native-array';

/**
 * @ArrayTransform
 * Deserialize undefined or null values to empty array
 */
export default class ArrayTransform extends Transform {
  deserialize(value: unknown[]): unknown[] {
    return A(Array.isArray(value) ? value : []);
  }

  serialize(value: unknown[]): unknown[] {
    return A(Array.isArray(value) ? value : []);
  }
}

declare module 'ember-data/types/registries/transform' {
  export default interface ModelRegistry {
    array: NativeArray<any>;
  }
}
